export type LegendItem = {
    label: string;
    color: string;
};

type BarChartLegendProps = {
    items: LegendItem[];
};

/**
 * A simple horizontal legend for bar charts with colored square indicators
 *
 * @example
 * ```tsx
 * <BarChartLegend
 *     items={[
 *         { label: 'Savings ($)', color: DASHBOARD_COLORS.ACCENT_1 },
 *         { label: 'Revenue', color: DASHBOARD_COLORS.ACCENT_2 },
 *     ]}
 * />
 * ```
 */
export function BarChartLegend({ items }: BarChartLegendProps) {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '1em' }}>
            {items.map((item) => (
                <div
                    key={item.label}
                    style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}
                >
                    <div
                        style={{
                            width: 14,
                            height: 14,
                            backgroundColor: item.color,
                            borderRadius: 2,
                        }}
                    />
                    <span>{item.label}</span>
                </div>
            ))}
        </div>
    );
}
